import { request } from '../../sharedLegacy/utils'

// These endpoints are still on API v1, which only returns JSON when explicitly
// asked via `format=json&raw=1`. The new fetch layer no longer injects those, so
// we pass them here until these calls are migrated to `/api/2/...`.
const V1_JSON = { format: 'json', raw: '1' }

export const getQueuedVideos = (liveId) => {
  const url = '/api/photo/list'

  return request({
    url,
    method: 'POST',
    data: {
      queued_for_live_id: liveId,
      ...V1_JSON,
    },
  })
}

export const queueVideo = (videoId, liveId) => {
  const url = '/api/live/queuedvideos/add'

  return request({
    url,
    method: 'POST',
    data: {
      photo_id: videoId,
      live_id: liveId,
      ...V1_JSON,
    },
  })
}

export const dequeueVideo = (videoId, liveId) => {
  const url = '/api/live/queuedvideos/remove'

  return request({
    url,
    method: 'POST',
    data: {
      photo_id: videoId,
      live_id: liveId,
      ...V1_JSON,
    },
  })
}
